import { render, staticRenderFns } from "./TemplateCalender.vue?vue&type=template&id=ed912466&"
import script from "./TemplateCalender.vue?vue&type=script&lang=js&"
export * from "./TemplateCalender.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCalender.vue?vue&type=style&index=0&id=ed912466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports